/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Promise = _interopDefault(require('babel-runtime/core-js/promise'));
var _noop = _interopDefault(require('lodash/fp/noop'));
var _isFunction = _interopDefault(require('lodash/fp/isFunction'));
var core = require('../core');

/**
 * Style function component for advanced styling.
 * Plays the role of both a style that mounts itself to style target component (vl-layer-vector, vl-feature & etc.)
 * and style target for inner style containers (vl-style-box) as fallback style.
 */

var props = {
  /**
   * @type {function(): ol.StyleFunction}
   */
  factory: {
    type: Function,
    required: true
  }
};

var computed = {
  styleFunc: function styleFunc() {
    var func = this.factory();
    if (!_isFunction(func)) {
      core.debug.warndbg('Factory returned a value not of Function type, fallback style will be used');
      func = _noop;
    }

    return func;
  }
};

var methods = {
  /**
   * @return {ol.StyleFunction}
   * @protected
   */
  createStyle: function createStyle() {
    core.assert.hasMap(this);
    // user provided style function
    var providedStyleFunc = this.styleFunc;
    // fallback style function made from inner style containers
    var fallbackStyleFunc = this.createStyleFunc();

    return function __styleFunc(feature, resolution) {
      var styles = providedStyleFunc(feature, resolution);
      // not empty or null style
      if (styles === null || Array.isArray(styles) && styles.length) {
        return styles;
      }
      return fallbackStyleFunc(feature, resolution);
    };
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    this.$stylesContainer && this.$stylesContainer.addStyle(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    this.$stylesContainer && this.$stylesContainer.removeStyle(this);
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return core.mergeDescriptors(core.style.methods.getServices.call(this), {
      get stylesContainer() {
        return vm;
      }
    });
  },

  /**
   * Overrides stylesContainer `setStyle` method
   * @param {Array<{ style: ol.style.Style, condition: (function|boolean|undefined) }>|ol.StyleFunction|Vue|undefined} styles
   * @return {void}
   */
  setStyle: function setStyle(styles) {
    if (styles !== this._styles) {
      // simply save all inner styles and
      // use them later in style function as fallback
      this._styles = styles;
      this.refresh();
    }
  },

  /**
   * @return {Promise}
   */
  refresh: function refresh() {
    // recreate style
    return _Promise.resolve(this.unmount()).then(this.deinit).then(this.init).then(this.mount);
  }
};

var watch = {
  factory: function factory() {
    this.refresh();
  }
};

var Style = {
  name: 'vl-style-func',
  mixins: [core.style, core.stylesContainer],
  props: props,
  computed: computed,
  methods: methods,
  watch: watch,
  stubVNode: {
    empty: false,
    attrs: function attrs() {
      return {
        class: this.$options.name
      };
    }
  }
};

var index = {
  Style: Style,
  install: function install(Vue) {
    Vue.component(Style.name, Style);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/style-func/index.js
// module id = 1199
// module chunks = 1